import * as React from "react";
import { Link } from "components/common";
import Routes from "routing/Routes";
const _getSourceType = (authServiceId, type = "") => {
  if (type === "SYNCED" && authServiceId) {
    return /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.AUTHENTICATION.BACKENDS.show(authServiceId) }, type.toLowerCase());
  }
  return type.toLowerCase();
};
const SourceTypeCell = ({ team: { type, authServiceId } }) => {
  const sourceType = _getSourceType(authServiceId, type);
  return /* @__PURE__ */ React.createElement("td", null, sourceType);
};
export default SourceTypeCell;
